export default {
  SEARCH_TRANSACTION_STATUS_REPOSITORY: Symbol.for('SEARCH_TRANSACTION_STATUS_REPOSITORY'),
  TRANSACTION_STATUS_STATE_MANAGER: Symbol.for('TRANSACTION_STATUS_STATE_MANAGER'),
  SEARCH_TRANSACTION_STATUS_QUERY: Symbol.for('SEARCH_TRANSACTION_STATUS_QUERY'),
};
